import React, { useEffect } from "react"

import { blogType2coupangAds } from "../../utils/blogTypes"
import "./index.scss"

const CoupangLinkDiv = ({
    post
}) => {
    let blogType = ""
    for (let _blogType in blogType2coupangAds) {
        let isContainBlogType = post.fileAbsolutePath.includes(_blogType)
        if (isContainBlogType) blogType = _blogType
    }
    
    return (
        <ul className="coupangLink--ul">
            {
                blogType2coupangAds[blogType].map((src, idx) => (
                    <li 
                        key={`coupang_ads_${idx}`}
                        className="coupangLink--li" 
                        dangerouslySetInnerHTML={{__html: src}}></li>
                ))
            }
        </ul>
    )
}

export default CoupangLinkDiv
